import { useState, useEffect } from 'react';
import { getUserStatus, UserStatus } from '../services/api';
import { logger } from '../utils/logger';

const DEFAULT_STATUS: UserStatus = {
    isAuthenticated: false,
    isOwner: false,
    canModifyTrip: false,
    hasEditsAvailable: false,
    isPublic: false,
    isTripUnlocked: false,
    freeEditsUsed: 0,
    freeEditsRemaining: 0,
    isPremium: false,
    dailyEditsToday: 0,
    dailyLimitReached: false,
};

/**
 * Hook to manage user status and edit entitlements.
 */
export function useUserStatus(tripSlug?: string) {
    const [userStatus, setUserStatus] = useState<UserStatus | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const refreshStatus = async () => {
        try {
            const status = await getUserStatus(tripSlug);
            setUserStatus(status);
            setError(null);
            return status;
        } catch (err) {
            logger.error('Failed to fetch user status:', err);
            // Default to anonymous status on error/unauthorized
            setUserStatus(DEFAULT_STATUS);
            setError(err instanceof Error ? err : new Error('Unknown error'));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let active = true;

        const fetch = async () => {
            const status = await refreshStatus();
            if (active && status) {
                // Status already set by refreshStatus
            }
        };

        fetch();

        return () => { active = false; };
    }, [tripSlug]);

    return { userStatus, loading, error, refreshStatus, setUserStatus };
}
